const Loader = () => {
  return (
    <div className="flex items-center justify-center py-8">
      <div className="w-16 h-16 border-4 border-slate-300 border-t-cyan-500 rounded-full animate-spin"></div>
    </div>
  );
};

export default Loader;
